package com.trevorwiebe.timesheet.calendar.presentation.composables

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.trevorwiebe.timesheet.calendar.presentation.uiHelper.DayUi
import kotlin.time.Clock
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.toLocalDateTime
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalFoundationApi::class, ExperimentalTime::class)
@Composable
fun DayBlock(
    dayUi: DayUi,
    onClick: () -> Unit,
    onLongClick: () -> Unit,
) {

    val background = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.tertiary else MaterialTheme.colorScheme.surface
    val todayLabelBackground = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.background else MaterialTheme.colorScheme.tertiary
    val todayLabelTextColor = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.onBackground else MaterialTheme.colorScheme.onTertiary
    val otherDateTextColor = if (dayUi.selectedForTimeOff) MaterialTheme.colorScheme.onTertiary else MaterialTheme.colorScheme.onSurface

    fun monthName(monthNumber: Int): String {
        return when (monthNumber) {
            1 -> "Jan"
            2 -> "Feb"
            3 -> "Mar"
            4 -> "Apr"
            5 -> "May"
            6 -> "Jun"
            7 -> "Jul"
            8 -> "Aug"
            9 -> "Sep"
            10 -> "Oct"
            11 -> "Nov"
            12 -> "Dec"
            else -> ""
        }
    }

    val dayOfMonthString = if (dayUi.date.dayOfMonth == 1) {
        "${monthName(dayUi.date.month.number)} ${dayUi.date.dayOfMonth}"
    } else {
        dayUi.date.dayOfMonth.toString()
    }

    val fontWeight = if (dayUi.date.dayOfMonth == 1) {
        FontWeight.Bold
    } else {
        FontWeight.Normal
    }

    Column(
        modifier = Modifier
            .padding(2.dp)
            .clip(RoundedCornerShape(6.dp))
            .combinedClickable(
                onClick = { onClick() },
                onLongClick = { onLongClick() }
            )
            .background(background)
            .height(96.dp)
    ) {
        if (dayUi.date == Clock.System.now()
                .toLocalDateTime(TimeZone.currentSystemDefault()).date
        ) {
            TodayBlockDateLabel(
                date = dayOfMonthString,
                backgroundColor = todayLabelBackground,
                textColor = todayLabelTextColor,
                fontWeight = fontWeight
            )
        } else {
            Text(
                modifier = Modifier.padding(2.dp, 0.dp, 2.dp, 0.dp),
                text = dayOfMonthString,
                fontSize = 14.sp,
                color = otherDateTextColor,
                fontWeight = fontWeight
            )
        }

        val userList = dayUi.employeesOff

        if (userList.size <= 3) {
            userList.forEach {
                DayBlockEventItem(
                    employeeName = it.employeeName ?: "unavailable",
                    approved = it.request.approved
                )
            }
        } else {
            userList.take(2).forEach {
                DayBlockEventItem(
                    employeeName = it.employeeName ?: "unavailable",
                    approved = it.request.approved
                )
            }
            MoreEventsEllipsis()
        }
    }
}